import React from "react";

const Spinner = ({ size = 32, color = "#888", label = "Loading..." }) => {
  const borderSize = Math.max(2, Math.floor(size / 8));
  const style = {
    width: size,
    height: size,
    border: `${borderSize}px solid ${color}33`,
    borderTop: `${borderSize}px solid ${color}`,
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <div style={style} />
      {label ? <span style={{ color: "#666", fontSize: 12 }}>{label}</span> : null}
      <style>
        {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        `}
      </style>
    </div>
  );
};

export default Spinner;


